<template>
  <div class="d-inline-flex">
    <v-menu v-for="version in versions" :key="version.key" offset-y :disabled="!!loading">
      <template #activator="{ on }">
        <v-btn
          color="primary darken-1"
          text
          :loading="loading === version.key"
          :disabled="!!loading"
          v-on="on"
        >
          <v-icon left>{{ version.icon }}</v-icon>
          {{ $t(version.label) }}
          <v-icon right>mdi-menu-down</v-icon>
        </v-btn>
      </template>
      <v-list class="text-start" dense>
        <v-list-item
          v-for="(color, index) in colors"
          :key="index"
          link
          @click="$emit('download', version.key, color)"
        >
          <v-img :src="getImageSrc(color)" width="50px" max-width="50px"></v-img>
          <v-list-item-title class="ml-2">{{ color.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
  import utils from '@/assets/js/utils'

  // Digital / Print certificate buttons with the store's colour list, same
  // choices as the cert menus in ManageOrders. Emits ('download', version, color).
  export default {
    props: {
      store: {
        type: Object,
        default: null,
      },
      // version key ('digital' | 'print') currently generating, or null
      loading: {
        type: String,
        default: null,
      },
    },
    data() {
      return {
        versions: [
          { key: 'digital', icon: 'mdi-download-outline', label: 'Digital' },
          { key: 'print', icon: 'mdi-printer-outline', label: 'Print' },
        ],
      }
    },
    computed: {
      colors() {
        const colors = this.store?.colors
        return colors && colors.length ? colors : [{ title: 'Default', value: 'default' }]
      },
    },
    methods: {
      getImageSrc(color) {
        return utils.getImageSrc(color, this.store)
      },
    },
  }
</script>
